export const SERVER_URL: string | undefined = process.env.REACT_APP_SERVER_URL;
export const RAZORPAY_KEY: string | undefined = process.env.REACT_APP_RAZORPAY_KEY;
